import { useMsal } from '@azure/msal-react';
import { useSelector } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';

const SSO = () => {
    const { instance } = useMsal();
    const loggingOutSSO = useSelector(
        (state) => state.loginReducer.loggingOutSSO
    );
    useEffectWithErrorLogging(() => {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        // Set active acccount on page load
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
        }

        instance.addEventCallback(
            (event) => {
                // set active account after redirect
                if (
                    event.eventType === 'msal:loginSuccess' &&
                    event.payload.account
                ) {
                    const account = event.payload.account;
                    instance.setActiveAccount(account);
                }
            },
            (error) => {
                logErrorToConsole(
                    'Error fetching accont details for the user',
                    error
                );
            }
        );

        // handle auth redired/do all initial setup for msal
        if (!loggingOutSSO) {
            instance
                .handleRedirectPromise()
                .then(() => {
                    // Check if user signed in
                    const account = instance.getActiveAccount();
                    if (!account) {
                        // redirect anonymous user to login page
                        instance.loginRedirect();
                    }
                })
                .catch((err) => {
                    // TODO: Handle errors
                    logErrorToConsole('Error handling redirect promise', err);
                });
        }
    }, [instance]);

    return '';
};

export default SSO;
